import React from 'react'
import PropTypes from 'prop-types'
import { Trans } from '@lingui/macro'

import './YotiButtonLink.scss'

const YotiButtonLink = ({ learnMoreLink }) => (
  <div className="yoti-button-link">
    <a className="yoti-button-link--anchor" href={learnMoreLink} target="_blank" rel="noopener">
      <Trans>How to set up your Yoti</Trans>
    </a>
  </div>
)

YotiButtonLink.propTypes = {
  learnMoreLink: PropTypes.string.isRequired
}

export default YotiButtonLink;
